import React from 'react'

import TenantsList from '../../components/Tenants/TenantsList'
import CommunityBoard from '../../components/Tenants/CommunityBoard'
import TenantsAlert from '../../components/Tenants/TenantsAlert'
import NavLink from '../../components/Routes/NavLink'
import ChargesList from '../../components/Tenants/Charges/ChargesList'
import CreditsList from '../../components/Tenants/Credits/CreditsList'
import CardHolder from '../../helpers/Cards/CardHolder'

import {NewTenants , TenantsLateOnRentTally, ExpiringLeases, TotalTenants } from '../../helpers/Cards/Cards';

import { tenants } from '../../core/controllers/tenants'
import { TabGroup } from '../../helpers/Tabs/TabGroup'
import { Tab } from '../../helpers/Tabs/Tab'

export default class TenantsTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filter: props.filter.filter,
        };
    }

    componentDidMount() {
        var self = this;
        tenants.getTenants(null, function(response) {
            self.setState({ data: response.data });
        });
    }

    updateFilter(type) {
        if (this.state.filter == type) {
            type = null;
        }

        this.setState({
            filter: type
        });
    }

    render(){
        var late = '';
        var selected = this.state.filter;
        if (selected != null) {
            if (selected == 'late') {
                late = 'selected';
            }
        }

        var tenantsExist = false;
        if (this.state.data != null) {
            if (this.state.data.length == 0) {
                tenantsExist = false;
            } else {
                tenantsExist = true;
            }
        }

        return (
            <div>
                {tenantsExist == true ? (
                    <div>
                    <div class="row">
                        <div class="main-page-header-row col-md-12">
                            <div class="col-md-3 col-sm-6 col-xs-6">
                                <span class="main-page-header-title">Tenants</span>
                            </div>
                            <div class="col-md-2 col-md-offset-7 col-sm-6 col-xs-6">
                                <NavLink to={"/tenant/new"}>
                                    <button type="button" id="add-tenant" data-loading-text="Loading..." class="add-tenant btn btn-info btn-fill pull-right" autoComplete="off">Add Tenant</button>
                                    <div class="clearfix"></div>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                    <br/>
                    <TabGroup>
                        <Tab title="overview">
                            <div>
                                <div class="row">
                                    <div className="col-md-12">
                                        <CardHolder width="100%" columnCount={4} paddingWidth={15}>
                                            <NewTenants clickable={true} />
                                            <TenantsLateOnRentTally clickable={true} />
                                            <ExpiringLeases clickable={true} />
                                            <TotalTenants followUp={"follow_up"} clickable={true} />
                                        </CardHolder>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="card">
                                            <div class="header col-md-4 col-sm-12 col-xs-12">
                                                <h4 class="title">Tenants</h4>
                                                <p class="category">Complete list of all tenants</p>
                                            </div>
                                            <div class="filter-options col-md-8 col-sm-12 col-xs-12">
                                                <label class="filter-checkbox-container">Recently Added
                                                    <input type="checkbox" class="filter-checkbox" onClick={this.updateFilter.bind(this, 'recent_added')} />
                                                </label>
                                                <label class="filter-checkbox-container">Late Rent
                                                    <input type="checkbox" class="filter-checkbox" onClick={this.updateFilter.bind(this, 'late')} />
                                                </label>
                                                {/* { selected != null && (
                                        <span class="clickable-action" onClick={this.updateFilter.bind(this, null)}>reset table</span>
                                    )} */}
                                            </div>
                                            <TenantsList data={[]} filter={this.state.filter} />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="card">
                                        <div class="header">
                                            <h4 class="title">Community Board</h4>
                                            <p class="category">All tenants will see this message on their dashboard.</p>
                                        </div>
                                        <CommunityBoard showEdit={true} />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="card">
                                        <div class="header">
                                            <h4 class="title">Send Alert</h4>
                                            <p class="category">All tenants will receive an email.</p>
                                        </div>
                                        <TenantsAlert />
                                    </div>
                                </div>
                            </div>
                        </Tab>
                        <Tab title="charges">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="header col-md-6 col-sm-12 col-xs-12">
                                            <h4 class="title">Charges</h4>
                                            <p class="category">Complete list of all charges</p>
                                        </div>
                                        <ChargesList />
                                    </div>
                                </div>
                            </div>
                        </Tab>
                        <Tab title="credits">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="header col-md-6 col-sm-12 col-xs-12">
                                            <h4 class="title">Credits</h4>
                                            <p class="category">Complete list of all credits</p>
                                        </div>
                                        <CreditsList />
                                    </div>
                                </div>
                            </div>
                        </Tab>
                    </TabGroup>
                </div>
                ) : (
                    <div>
                        <div  style={{textAlign: "center"}}>
                            <div class="row">
                                <div class="main-page-header-row col-md-12">
                                    <div>
                                        <div class="row">
                                            <span class="main-page-header-title">No Tenants Yet</span>
                                        </div>
                                        <div class="row" style={{marginTop: "10px"}}>
                                            <NavLink to={"/tenant/new"}>
                                                <button type="button" id="add-tenant" data-loading-text="Loading..." class="add-tenant btn btn-info btn-fill" autoComplete="off">Add Tenant</button>
                                                <div class="clearfix"></div>
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12" style={{backgroundImage: "url('/assets/img/ListingTenant.png')", backgroundRepeat: 'no-repeat', backgroundPosition: 'top', backgroundSize: 'contain', minHeight: '560px'}}></div>
                    </div>
                )} 
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/views/Tenants/Tenants.jsx